/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Organization } from './organization';
/**
 * 
 * @export
 * @interface WastePassport
 */
export interface WastePassport {
    /**
     * 
     * @type {string}
     * @memberof WastePassport
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WastePassport
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WastePassport
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WastePassport
     */
    hazard: WastePassportHazardEnum;
    /**
     * 
     * @type {string}
     * @memberof WastePassport
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof WastePassport
     */
    comment: string;
    /**
     * 
     * @type {boolean}
     * @memberof WastePassport
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WastePassport
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WastePassport
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WastePassport
     */
    deletedAt: Date;
    /**
     * 
     * @type {Organization}
     * @memberof WastePassport
     */
    organization: Organization;
}

/**
    * @export
    * @enum {string}
    */
export enum WastePassportHazardEnum {
    DANGER = 'DANGER',
    NOTDANGER = 'NOT_DANGER',
    MIRROR = 'MIRROR'
}

